<template>
  <page-outline :title="$t('administration.user_edit')">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <form-accordion v-else  :isTitleUpperCase="false" :title="$t('administration.user_info')">
          <div class="form-group">
          </div>
          <b-row>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="login" isMandatory
                :inputLabel="$t('administration.identifier')" :placeholderValue="$t('administration.identifier')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="name" isMandatory
                :inputLabel="$t('administration.user_name')" :placeholderValue="$t('administration.user_name')">
              </form-write-group-label-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" class="form-group">
              <label for="sel4">
                {{ $t('administration.active') }}
              </label>
              <select class="form-control" id="sel4" v-model="active" readonly
                :aria-label="$t('administration.active')">
                <option value="0"> {{ $t('administration.no') }} </option>
                <option value="2"> {{ $t('administration.yes') }} </option>
              </select>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" class="form-group">
              <b-form-checkbox v-model="changePassword" :checked="false">
                <span>{{ $t('administration.reset_password') }}</span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row v-if="changePassword">
            <b-col sm="6" class="form-group">
              <label>{{$t('common.pwd')}}</label>
              <div class="d-flex">
                <input v-model="password"
                  class="form-control inputAccordionForm h-30px"
                  :type="passwordType"
                  :placeholder="$t('common.pwd')"
                  autocomplete="new-password">
                  <button type="button" class="icon icon-password mt-2 pt-1 icon-field"
                    :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                    @click="switchPasswordType"
                    :aria-label="isPasswordFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                    :aria-pressed="!isPasswordFieldHidden">
                  </button>
                </input>
              </div>
            </b-col>
            <b-col sm="6" class="form-group">
              <label>{{$t('common.security.verif_password')}}</label>
              <div class="d-flex">
                <input v-model="passwordVerif"
                  class="form-control inputAccordionForm h-30px"
                  :type="passwordVerifType"
                  :placeholder="$t('common.security.verif_password')"
                  autocomplete="new-password">
                  <button type="button" class="icon icon-password mt-2 pt-1 icon-field"
                    :class="[isPasswordVerifFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                    @click="switchPasswordVerifType"
                    :aria-label="isPasswordVerifFieldHidden ? $t('common.show_password') : $t('common.hide_password')"
                    :aria-pressed="!isPasswordVerifFieldHidden">
                  </button>
                </input>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" sm="6" class="form-group">
              <b-form-checkbox v-model="firstLogin"
                value="1"
                unchecked-value="0"
                :disabled="receivedFirstLogin">
                <span>{{receivedFirstLogin ? $t('administration.reset_password_option') + ' ' + $t('common.active_par') : $t('administration.reset_password_option')}}</span>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <form-accordion :title="$t('administration.user_auth')"  :isTitleUpperCase="false">
            <b-row class="justify-content-start">
              <b-col cols="4">
                <b-col cols="12" class="px-0">
                  <label for="user-profile-select">
                    {{ $t('administration.profile') }}
                  </label>
                  <select class="form-control" id="user-profile-select" v-model="idProfile"
                    :aria-label="$t('administration.profile')">
                    <option value="" disabled>{{ $t('administration.select_profile') }}</option>
                    <option v-for="(profile, index) in AllProfiles" :key="'filtered-profile-' + profile.id + '-' + index" :value="profile.id" :disabled="profile.disabled">
                      {{ profile.name }}
                    </option>
                  </select>
                </b-col>
              </b-col>
            </b-row>
            <b-row class="justify-content-start">

            </b-row>
          </form-accordion>

        </form-accordion>
      </b-container>
    </template>
    <template slot="bottomActions">
      <app-button
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        @click="changeUser">
      </app-button>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import AppButton from '@/components/common/AppButton.vue'
import {errorMessageAlert} from '@/helpers/alert'
import Spinner from '@/components/common/spinner.vue'

import {loadPage, reloadPage} from '@/helpers/routing'
// import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'app-button': AppButton,
    'spinner': Spinner
  },
  props: ['idUserAcc', 'idCompany'],
  computed: {
    AllProfiles () {
      let that = this
      console.log('profiles', this.profiles)
      let existingProfile = this.profiles.find(elem => elem.idAccount === that.$engine.firstOn().user.get().id)
      console.log('existingProfile.profiles', existingProfile.profiles)
      return existingProfile.profiles
    },
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    isPasswordVerifFieldHidden () {
      return this.passwordVerifType === 'password'
    }
  },
  data () {
    return {
      activateSpinner: false,
      active: '',
      changePassword: false,
      idProfile: '',
      firstLogin: '0',
      hrtpNorm: false,
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      passwordVerif: '',
      passwordVerifType: 'password',
      profiles: [],
      receivedFirstLogin: false,
      Users: []
      // returnUrl: "/usercompany/" // '/detail/' + idCompany
    }
  },
  created () {
    let that = this
    this.$engine.firstOn().company.profiles.forEach(profile => {
      let existingProfile = that.profiles.find(obj => obj.idAccount === profile.idAccount)
      if (!existingProfile) {
        that.profiles.push({
          idAccount: profile.idAccount,
          name: profile.nameAccount,
          profiles: [{
            id: profile.id_rights_profile,
            name: profile.libelle
          }]
        })
      } else if (!existingProfile.profiles.some(obj => obj.id === profile.id_rights_profile)) {
        existingProfile.profiles.push({
          id: profile.id_rights_profile,
          name: profile.libelle
        })
      }
    })
    this.atStart(this.idUserAcc)
  },
  methods: {
    atStart (val = 1) {
      let that = this
      that.Users = []
      that.$engine.firstOn().usercompany.getUser(
        val,
        10,
        1
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users && resp.data.users.length > 0) {
          requests = resp.data.users[0]
          that.Users.push(requests)
          this.updateModel()
        }
      }).catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    changeUser () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let payload = {
        IdCompany: this.idCompany && this.idCompany !== 'undefined' ? this.idCompany : this.$engine.firstOn().user.get().id,
        IdUserAccount: this.idUserAcc,
        IdRightsProfile: [this.idProfile],
        UserAccount: {
          IsFirstLogin: this.firstLogin,
          IdUser: this.idUserAcc,
          Login: this.login,
          Name: this.name,
          Active: this.active,
          Password: this.password
        }
      }
      this.$engine.firstOn().usercompany.editUser(payload)
      .then(resp => {
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_user'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        //that.$bus.$emit('switch-selected-menu', '/usercompany/')
        reloadPage(that, {url: /detailusercompany/ + that.idUserAcc + '/' + that.idCompany})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.$f7.modal({
          title: that.$i18n.t('administration.edit_error'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      })
    },
    formHasError() {
      let that = this
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.passwordVerif && (this.password === undefined || this.password === '')) {
        this.okMessageBox(this.$t('errors.new_pwd_mssng'))
        return true
      }
      if (this.password && (this.passwordVerif === undefined || this.passwordVerif === '')) {
        this.okMessageBox(this.$t('usercompany.missing_password_verif'))
        return true
      }
      if (this.password && !regexPassword.test(this.password)) {
        this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
        return true
      }
      if (this.passwordVerif !== this.password) {
        this.okMessageBox(this.$t('usercompany.passwords_not_matching'))
        return true
      }
      if (!this.idProfile) {
        this.okMessageBox(this.$t('usercompany.missing_profile'))
        return true
      }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    switchPasswordVerifType () {
      if (this.passwordVerifType === 'password') {
        this.passwordVerifType = 'text'
      } else {
        this.passwordVerifType = 'password'
      }
    },
    goBack () {
      if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === '/login/') {
        loadPage(this, {url: '/home/'})
      } else {
        if (this.$f7.mainView.history[this.$f7.mainView.history.length - 2] === this.$f7.mainView.history[this.$f7.mainView.history.length - 1]) {
          loadPage(this, {url: '/home/'})
        } else {
          this.$f7.mainView.router.back()
        }
        this.$bus.$emit('router-back')
      }
    },
    updateModel () {
      let that = this
      this.login = this.Users[0].Login
      this.active = this.Users[0].Active
      this.firstLogin = this.Users[0].IsFirstLogin
      if(this.Users[0].IsFirstLogin === '1') {
        this.receivedFirstLogin = true
      }
      // this.type = this.Users[0].user_account.type
      this.name = this.Users[0].Name
      this.idProfile = this.Users[0].Rights && this.Users[0].Rights.length ? this.Users[0].Rights[0].IdRightProfile : ''
      this.profiles.forEach(profile => {
        if (that.Users[0].Rights.filter(item => item.IdRightProfile === profile.id_rights_profile).length) {
          profile.state = 1
        }
      })
      this.profiles = _.cloneDeep(this.profiles).sort((a, b) => {
        return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
      })
    },
  }
}
</script>
